import { render, staticRenderFns } from "./DataMitraUsaha.vue?vue&type=template&id=d6d93188&"
import script from "./DataMitraUsaha.vue?vue&type=script&lang=js&"
export * from "./DataMitraUsaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports